import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import dayjs from 'dayjs';
import { typeEstruturaAtvsExecutadas } from './estrutura_todas_atvs';
import { HeaderDef } from '../../atvsTodas/meta/gerarPDFTodasAtivs';
import { logo_ttivos_base64 } from '../../../../../../../Components/GerarExcel/meta';
import secureLocalStorage from "react-secure-storage";

export const gerarExcelAtvsExecutadas = async (
    dados: typeEstruturaAtvsExecutadas[],
    headerInfo?: HeaderDef
) => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Relatório de Atividades', {
        views: [{ showGridLines: false }]
    });

    worksheet.columns = [
        { header: '', key: 'col1', width: 20 },
        { header: '', key: 'col2', width: 40 },
        { header: '', key: 'col3', width: 25 },
        { header: '', key: 'col4', width: 25 },
    ];

    let currentRow = 1;

    // ** HEADER **
    worksheet.getRow(currentRow).height = 40; // Linha para a imagem
    worksheet.getRow(currentRow + 1).height = 30; // Linha para o título
    worksheet.getRow(currentRow + 2).height = 20; // Linha para razao social

    // LOGO
    const headerImageId = workbook.addImage({
        base64: logo_ttivos_base64,
        extension: 'png',
    });

    worksheet.addImage(headerImageId, {
        tl: { col: 1.2, row: 0 },
        ext: { width: 121, height: 50 },
        editAs: 'LOGO TTIVOS'
    });
    worksheet.mergeCells(`A${currentRow}:D${currentRow}`);
    const logoRow = worksheet.getRow(currentRow);
    logoRow.getCell(1).alignment = { vertical: 'middle', horizontal: 'center' };
    for (let i = 1; i <= 4; i++) {
        logoRow.getCell(i).border = {
            bottom: { style: 'thin', color: { argb: 'FFD3D3D3' } }
        };
    }
    currentRow++;

    worksheet.mergeCells(`A${currentRow}:D${currentRow}`);
    const titleRow = worksheet.getRow(currentRow);
    titleRow.getCell(1).value = headerInfo?.titulo || 'Relatório de atividades executadas';
    titleRow.getCell(1).font = { size: 16, bold: true };
    titleRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle' };
    for (let i = 1; i <= 4; i++) {
        titleRow.getCell(i).border = {
            bottom: { style: 'thin', color: { argb: 'FFD3D3D3' } }
        };
    }
    currentRow++;

    worksheet.mergeCells(`A${currentRow}:D${currentRow}`);
    const razaoRow = worksheet.getRow(currentRow);
    razaoRow.getCell(1).value = headerInfo?.razaoSocial || '';
    razaoRow.getCell(1).font = { size: 10 };
    razaoRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle' };
    for (let i = 1; i <= 4; i++) {
        razaoRow.getCell(i).border = {
            bottom: { style: 'thin', color: { argb: 'FFD3D3D3' } }
        };
    }
    currentRow++;

    // ** CLIENTE, SAFRA, CULTURA **
    if (headerInfo?.cliente) {
        worksheet.getRow(currentRow).height = 10; // Espaçamento superior
        currentRow++;

        // --- ROW DE RÓTULOS (Labels) ---
        worksheet.getRow(currentRow).height = 15;
        worksheet.mergeCells(`A${currentRow}:B${currentRow}`);

        const labelRow = worksheet.getRow(currentRow);
        
        labelRow.getCell(1).value = 'CLIENTE';
        labelRow.getCell(3).value = 'SAFRA';
        labelRow.getCell(4).value = 'CULTURA';

        const labelFont = { size: 9, bold: true, color: { argb: 'FF7B7B7B' } };
        const centerAlignment = { horizontal: 'center', vertical: 'middle' } as const;

        labelRow.getCell(1).font = labelFont;
        labelRow.getCell(3).font = labelFont;
        labelRow.getCell(4).font = labelFont;

        labelRow.getCell(1).alignment = centerAlignment;
        labelRow.getCell(3).alignment = centerAlignment;
        labelRow.getCell(4).alignment = centerAlignment;

        currentRow++;

        // --- ROW DE VALORES ---
        worksheet.getRow(currentRow).height = 20;
        worksheet.mergeCells(`A${currentRow}:B${currentRow}`);

        const valueRow = worksheet.getRow(currentRow);
        
        valueRow.getCell(1).value = (headerInfo.cliente || '-').toUpperCase();
        valueRow.getCell(3).value = (headerInfo.safra || '-').toUpperCase();
        valueRow.getCell(4).value = (headerInfo.cultura || '-').toUpperCase();

        const valueFont = { size: 11, bold: true, color: { argb: 'FF000000' } };

        valueRow.getCell(1).font = valueFont;
        valueRow.getCell(3).font = valueFont;
        valueRow.getCell(4).font = valueFont;

        valueRow.getCell(1).alignment = centerAlignment;
        valueRow.getCell(3).alignment = centerAlignment;
        valueRow.getCell(4).alignment = centerAlignment;

        // Adiciona bordas ao redor da nossa tabela de dados
        const borderStyle: ExcelJS.Border = { style: 'thin', color: { argb: 'FF7B7B7B' } };
        
        const labelRowNumber = currentRow - 1;
        const valueRowNumber = currentRow;

        for (let col = 1; col <= 4; col++) {
            worksheet.getRow(labelRowNumber).getCell(col).border = {
                top: borderStyle,
                left: col === 1 || col === 3 || col === 4 ? borderStyle : undefined,
                right: col === 2 || col === 3 || col === 4 ? borderStyle : undefined,
            };
            worksheet.getRow(valueRowNumber).getCell(col).border = {
                bottom: borderStyle,
                left: col === 1 || col === 3 || col === 4 ? borderStyle : undefined,
                right: col === 2 || col === 3 || col === 4 ? borderStyle : undefined,
            };
        }

        currentRow++;
    }

    currentRow++; // linha vazia

    const applyBorders = (rowNum: number, color = 'FF000000', colCount = 4) => {
        const row = worksheet.getRow(rowNum);
        for (let i = 1; i <= colCount; i++) {
            row.getCell(i).border = {
                top: { style: 'thin', color: { argb: color } },
                left: { style: 'thin', color: { argb: color } },
                bottom: { style: 'thin', color: { argb: color } },
                right: { style: 'thin', color: { argb: color } }
            };
        }
    };

    dados.forEach((propriedade) => {
        worksheet.mergeCells(`A${currentRow}:D${currentRow}`);
        const propRow = worksheet.getRow(currentRow);
        propRow.getCell(1).value = propriedade.nome_propriedade || "PROPRIEDADE NÃO INFORMADA";
        propRow.getCell(1).font = { bold: true, color: { argb: 'FFFFFFFF' }, size: 12 };
        propRow.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF5DA57D' } };
        propRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle' };
        propRow.height = 25;
        applyBorders(currentRow, 'FF165C13');
        currentRow++;

        propriedade.lista_atividades_por_talhao.forEach((talhao) => {
            worksheet.mergeCells(`A${currentRow}:D${currentRow}`);
            const talhaoRow = worksheet.getRow(currentRow);
            talhaoRow.getCell(1).value = talhao.nome_talhao || "TALHÃO NÃO INFORMADO";
            talhaoRow.getCell(1).font = { bold: true, color: { argb: 'FF165C13' }, size: 11 };
            talhaoRow.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFFFF' } };
            talhaoRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle' };
            talhaoRow.height = 20;
            applyBorders(currentRow, 'FF165C13');
            currentRow++;

            talhao.lista_atividades.forEach((atv) => {

                const formatarData = (dInicio: string | null, dFim: string | null) => {
                    if (!dInicio && !dFim) return '-';
                    const i = dInicio ? dayjs(dInicio).format("DD/MM/YY") : '?';
                    const f = dFim ? dayjs(dFim).format("DD/MM/YY") : '?';
                    if (i === f) return i;
                    return `${i} | ${f}`;
                };

                const dataPlanejadaStr = formatarData(atv.data_inicio_planejada, atv.data_final_planejada);

                const isDiasNegativo = atv.dias < 0;
                const headerBgColor = isDiasNegativo ? 'FFE0EDF8' : 'FFEFFEDF';
                const headerTextColor = isDiasNegativo ? 'FF0958D9' : 'FF52C41A';

                // Atividade Header
                worksheet.mergeCells(`A${currentRow}:D${currentRow}`);
                const atvHeaderRow = worksheet.getRow(currentRow);
                atvHeaderRow.getCell(1).value = `${atv.nome_atv_planejada?.toUpperCase() || "ATIVIDADE"} - (${dataPlanejadaStr})`;
                atvHeaderRow.getCell(1).font = { bold: true, color: { argb: headerTextColor }, size: 10 };
                atvHeaderRow.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: headerBgColor } };
                atvHeaderRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle' };
                atvHeaderRow.height = 20;
                applyBorders(currentRow, headerTextColor);
                currentRow++;

                const headerTitles = ['Pontualidade', 'Operador', 'Data', 'Área'];
                const colHeaderRow = worksheet.getRow(currentRow);
                headerTitles.forEach((title, index) => {
                    const cell = colHeaderRow.getCell(index + 1);
                    cell.value = title;
                    cell.font = { bold: true, color: { argb: 'FFFFFFFF' } };
                    cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF0E743F' } };
                    cell.alignment = { horizontal: index === 0 ? 'center' : 'left', vertical: 'middle' };
                });
                colHeaderRow.height = 20;
                applyBorders(currentRow, 'FF000000');
                currentRow++;

                if (!atv.lista_execucoes || atv.lista_execucoes.length === 0) {
                    worksheet.mergeCells(`A${currentRow}:D${currentRow}`);
                    const noExecRow = worksheet.getRow(currentRow);
                    noExecRow.getCell(1).value = 'Nenhuma execução registrada';
                    noExecRow.getCell(1).font = { italic: true, color: { argb: 'FF666666' } };
                    noExecRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle' };
                    noExecRow.height = 25;
                    applyBorders(currentRow, 'FFBFBFBF');
                    currentRow++;
                } else {
                    atv.lista_execucoes.forEach((exec) => {
                        let textPontualidade = exec.pontualidade || "Indefinido";
                        if (textPontualidade === "Adiantada") textPontualidade = "Adiantado";
                        if (textPontualidade === "Atrasada") textPontualidade = "Atrasado";

                        let colorPontualidadeText = 'FF000000';
                        let colorPontualidadeBg = 'FFFFFFFF';

                        if (textPontualidade === "Adiantado") {
                            colorPontualidadeText = 'FFCB9700';
                            colorPontualidadeBg = 'FFFDF1D3';
                        } else if (textPontualidade === "Atrasado") {
                            colorPontualidadeText = 'FFC60B26';
                            colorPontualidadeBg = 'FFFDE5E5';
                        } else if (textPontualidade === "No prazo") {
                            colorPontualidadeText = 'FF238B22';
                            colorPontualidadeBg = 'FFE4F4E4';
                        }

                        const dataExecStr = exec.data_final ? dayjs(exec.data_final).format("DD/MM/YYYY") : '-';

                        const execRow = worksheet.getRow(currentRow);
                        execRow.getCell(1).value = textPontualidade;
                        execRow.getCell(2).value = exec.nome_usuario || '-';
                        execRow.getCell(3).value = dataExecStr;
                        execRow.getCell(4).value = `${exec.area} ha`;

                        execRow.height = 25;

                        // Alignments & Borders
                        for (let i = 1; i <= 4; i++) {
                            const cell = execRow.getCell(i);
                            cell.alignment = { horizontal: i === 1 ? 'center' : 'left', vertical: 'middle', wrapText: true };
                        }

                        // Colors
                        execRow.getCell(1).font = { bold: true, color: { argb: colorPontualidadeText } };
                        execRow.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: colorPontualidadeBg } };

                        // Outras células brancas
                        for (let i = 2; i <= 4; i++) {
                            execRow.getCell(i).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFFFF' } };
                        }

                        applyBorders(currentRow, 'FFBFBFBF');
                        currentRow++;
                    });
                }
                
                currentRow++; // Empty space between Atividades (mesclando com gap visual do PDF)
            });
            // currentRow não ganha extra line, a Atividade já deu

        });
        currentRow++; // empty space between propriedades
    });

    // ** FOOTER **
    const espacoRow = worksheet.addRow([]);
    espacoRow.height = 20;

    const email_usuario_logado = secureLocalStorage.getItem('Itens')?.[0]?.email?.toLowerCase() || '';
    const footerRow = worksheet.addRow([]);
    footerRow.getCell(1).value = `Gerado por: ${email_usuario_logado} - ${dayjs().format('DD/MM/YYYY HH:mm:ss')}`;
    footerRow.font = { italic: true };
    footerRow.alignment = { horizontal: 'center', vertical: 'middle' };

    for (let i = 1; i <= 4; i++) {
        worksheet.getCell(`${String.fromCharCode(64 + i)}${footerRow.number}`).border = {
            top: { style: 'thin', color: { argb: 'FF5DA57D' } }
        };
    }
    worksheet.mergeCells(`A${footerRow.number}:D${footerRow.number}`);
    footerRow.height = 25;

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer as BlobPart], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    saveAs(blob, `Relatorio_Atividades_Executadas_${dayjs().format("DD_MM_YYYY_HH_mm")}.xlsx`);
};
